import { parseGameTime, getTimeRemaining } from './redeemTimeUtils';

/**
 * Determine the state of the Redeem button for a game
 * 
 * @param {object} game - Game row from database
 * @param {boolean} walletConnected - Whether wallet is connected
 * @param {string} tokenBalance - User's token balance for this mint (raw amount as string)
 * @returns {object} - Button state with enabled flag and display text
 */
export function getRedeemButtonState(game, walletConnected, tokenBalance = '0') {
  // Check wallet connection
  if (!walletConnected) {
    return {
      enabled: false,
      text: 'Connect Wallet',
      reason: 'wallet_not_connected',
    };
  }

  // Check status code
  if (game.status_code !== 3) {
    return {
      enabled: false,
      text: 'Not Redeemable',
      reason: 'invalid_status',
    };
  }

  // Parse redeem end time
  const redeemEndTime = parseGameTime(game.redeem_end_time);
  if (!redeemEndTime) {
    return {
      enabled: false,
      text: 'Invalid Time',
      reason: 'invalid_time',
    };
  }

  // Check if redeem window has expired
  const timeRemaining = getTimeRemaining(redeemEndTime);
  if (timeRemaining.isExpired) {
    return {
      enabled: false,
      text: 'Expired',
      reason: 'expired',
    };
  }

  // Button should always allow opening the modal when wallet is connected
  // and the window hasn't expired, even if balance is 0
  // The modal will handle the actual submit button state
  return {
    enabled: true,
    text: 'Redeem',
    reason: 'ready',
  };
}

/**
 * Determine the state of the Close Game button for a game
 * 
 * @param {object} game - Game row from database
 * @returns {object} - Button state with enabled flag and display text
 */
export function getCloseGameButtonState(game) {
  // Check status code
  if (game.status_code !== 3) {
    return {
      enabled: false,
      text: 'Cannot Close',
      reason: 'invalid_status',
    };
  }

  // Parse redeem end time
  const redeemEndTime = parseGameTime(game.redeem_end_time);
  if (!redeemEndTime) {
    return {
      enabled: false,
      text: 'Invalid Time',
      reason: 'invalid_time',
    };
  }

  // Check if redeem window has expired
  const timeRemaining = getTimeRemaining(redeemEndTime);
  if (!timeRemaining.isExpired) {
    return {
      enabled: false,
      text: 'Close Game',
      reason: 'not_expired',
    };
  }

  // Ready to close
  return {
    enabled: true,
    text: 'Close Game',
    reason: 'ready',
  };
}
